import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { useAppDispatch } from '../useAppDispatch';

import { selectRealtor, selectUserAuthenticated, selectRealtyUserId } from '../../selectors';
import { openChatModal } from '../../store/chat_modal';
import { requestAuthentication } from '../../store/authentication';

export function useChats() {
  const { isChatsEnabled, realtyUserId: realtorRealtyUserId } = useSelector(selectRealtor);
  const realtyUserId = useSelector(selectRealtyUserId);

  const isOwnPage = Number(realtorRealtyUserId) && realtyUserId ? Number(realtorRealtyUserId) === realtyUserId : false;

  const isUserAuthenticated = useSelector(selectUserAuthenticated);
  const dispatch = useAppDispatch();

  const handleOpenChat = useCallback(() => {
    if (isUserAuthenticated) {
      dispatch(openChatModal());
    } else {
      dispatch(requestAuthentication());
    }
  }, [dispatch, isUserAuthenticated]);

  return useMemo(
    () => ({
      isEnabled: isChatsEnabled && !isOwnPage,
      openChat: handleOpenChat,
    }),
    [handleOpenChat, isChatsEnabled, isOwnPage],
  );
}
